import {
  blue,
  green,
  purple,
} from "@mui/material/colors";
import { useTheme } from "@mui/material/styles";
import { useNavigate } from "react-router-dom";
import * as DefaultRoutes from "@Routes/DefaultRoutes";
import GenericHomePage from "@Pages/GenericHomePage/GenericHomePage";
import AssignmentIndRoundedIcon from "@mui/icons-material/AssignmentIndRounded";
import HistoryRoundedIcon from "@mui/icons-material/HistoryRounded";
import HubRoundedIcon from "@mui/icons-material/HubRounded";

const SupportProviderHome = () => {
  const navigate = useNavigate();
  const theme = useTheme();

  let sectionsBox = [
    {
      textBeside: "Pending Approvals",
      icon: AssignmentIndRoundedIcon,
      iconColor: blue[700],
      iconFontSize: theme.spacing(10),
      boxbackgroundColor: blue[100],
      onClick: () => navigate(DefaultRoutes.supportProviderAssignedRequests),
    },
    {
      textBeside: "My Approvals History",
      icon: HistoryRoundedIcon,
      iconColor: purple[700],
      iconFontSize: theme.spacing(10),
      boxbackgroundColor: purple[100],
      onClick: () => navigate(DefaultRoutes.supportProviderAllRequests),
    },
    {
      textBeside: "Regulatory Ingredients Hub",
      icon: HubRoundedIcon,
      iconColor: green[700],
      iconFontSize: theme.spacing(10),
      boxbackgroundColor: green[100],
      onClick: () => navigate(DefaultRoutes.supportProviderRequestsHub),
    },
  ];

  return <GenericHomePage sectionsBox={sectionsBox} />;
};

export default SupportProviderHome;
